export const Textarea = (props) => {
    const { name, value } = props;
    return (
        <div key={name} className="row">
            <label className="label" htmlFor={name}>{name}</label>
            <textarea id={name} name={name} rows="30" cols="40" defaultValue={value} />
        </div>
    )
}